import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Laboratory",
  "use": "icon-Laboratory-usage",
  "viewBox": "0 0 1151 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1151 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-Laboratory\"><defs><style type=\"text/css\"></style></defs><path d=\"M1134.984827 849.830768l-351.963044-558.021408V102.389249h52.47449a51.194625 51.194625 0 1 0 0-102.389249h-524.744902a51.194625 51.194625 0 1 0 0 102.389249h52.47449v209.897961l-346.459621 537.543558A115.699852 115.699852 0 0 0 121.587233 1023.892491h913.440089a115.187905 115.187905 0 0 0 99.765525-174.061723zM468.238835 343.003985V102.389249H678.328775v215.017423L793.516681 511.946246h-10.238925C625.790292 511.946246 573.251809 614.335495 415.764345 614.335495a337.308583 337.308583 0 0 1-99.765525-15.358388z m0 0\" p-id=\"2458\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/Laboratory.svg
// module id = fUlr
// module chunks = 77